import {
  guardApiSizeInCatalog,
  guardComicReferenceModel,
  guardHasReferenceCapableModels,
  type GuardResult,
  runGuards,
} from '@glyphic/shared-core'

import type { ClientUiPublic } from '../../api/platformConfig'
import type { ComicProjectSettings } from '../comicDomainTypes'
import {
  allowedApiSizesForModel,
  toImageGenModelCatalog,
  toReferenceCapableCatalog,
} from './imageGenCatalog'

/**
 * 漫画整页/话级生图前统一预检（与后端 ComicPageGenerationGuard 语义对齐）。
 */
export function runComicGenerationPreflight(
  settings: ComicProjectSettings,
  clientUi: ClientUiPublic,
): GuardResult {
  const catalog = toImageGenModelCatalog(clientUi)
  const referenceCapable = toReferenceCapableCatalog(clientUi)
  const allowedSizes = allowedApiSizesForModel(
    clientUi,
    settings.platformId,
    settings.modelId,
  )

  return runGuards(
    () => guardHasReferenceCapableModels(catalog),
    () => guardComicReferenceModel(settings, referenceCapable),
    () => guardApiSizeInCatalog(settings.apiSize, allowedSizes),
  )
}
